"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumProductAnalyticsEvent = void 0;
/**
 * The event names that will be sent to Amplitude.
 */
exports.EnumProductAnalyticsEvent = {
    ScreenViewed: 'Screen: Viewed',
    PackItemClicked: 'Pack: Item: Clicked',
    PackItemViewed: 'Pack: Item: Viewed',
    ProgramItemClicked: 'Program: Item: Clicked',
    ButtonClicked: 'Button: Clicked',
    LoginSuccess: 'Login: Success',
    SignupSuccess: 'Signup: Success',
    AccessCodeSubmitted: 'Access Code : Submitted',
    SponsorshipAddedSuccess: 'Sponsorship : Added : Success',
    FtueGoalsChoiceAdded: 'FTUE : Goals : Choice Added',
    FtueGoalsReset: 'FTUE : Goals : Reset',
    FtueGoalsSubmitted: 'FTUE : Goals : Submitted',
    FtueGoalsSkipped: 'FTUE : Goals : Skipped',
    FtueTopicsChoiceAdded: 'FTUE : Topics : Choice Added',
    FtueTopicsReset: 'FTUE : Topics : Reset',
    FtueTopicsSubmitted: 'FTUE : Topics : Submitted',
    FtueTopicsSkipped: 'FTUE : Topics : Skipped',
    FtueConditionsAdded: 'FTUE : Conditions : Added',
    FtueConditionsSubmitted: 'FTUE : Conditions : Submitted',
    FtueConditionsSkipped: 'FTUE : Conditions : Skipped',
    FtueVideoStarted: 'FTUE : Video : Started',
    FtueVideoCompleted: 'FTUE : Video : Completed',
    FtueVideoSkipped: 'FTUE : Video : Skipped',
    UpdatePlanGoalsChoiceAdded: 'Update Plan : Goals : Choice Added',
    UpdatePlanGoalsReset: 'Update Plan : Goals : Reset',
    UpdatePlanGoalsSubmitted: 'Update Plan : Goals : Submitted',
    UpdatePlanGoalsCanceled: 'Update Plan : Goals : Canceled',
    UpdatePlanTopicsChoiceAdded: 'Update Plan : Topics : Choice Added',
    UpdatePlanTopicsReset: 'Update Plan : Topics : Reset',
    UpdatePlanTopicsSubmitted: 'Update Plan : Topics : Submitted',
    UpdatePlanTopicsCanceled: 'Update Plan : Topics : Canceled',
    UpdatePlanConditionsAdded: 'Update Plan : Conditions : Added',
    PlanUpdatedConditionsRemoved: 'PlanUpdated : Conditions : Removed',
    PlanUpdatedConditionsCanceled: 'PlanUpdated : Conditions : Canceled',
    PlanUpdatedConditionsSubmitted: 'PlanUpdated : Conditions : Submitted',
    SessionStarted: 'Session : Started',
    Session90PercentCompleted: 'Session : 90 Percent Completed',
    SessionCanceled: 'Session : Canceled',
    SessionCompleted: 'Session : Completed',
    SessionPaused: 'Session : Paused',
    SessionResumed: 'Session : Resumed',
    ClinicalProgramJoined: 'Clinical Program : Joined',
    ClinicalProgramCompleted: 'Clinical Program : Completed',
    ClinicalProgram50PercentCompleted: 'Clinical Program : 50 Percent Completed',
    NotificationsToggled: 'Notifications : Toggled',
    ContentFavorited: 'Content : Favorited',
    ContentUnfavorited: 'Content : Unfavorited',
};
//# sourceMappingURL=enum-product-analytics-event.js.map